import { defineMessages } from 'react-intl';

export default defineMessages({
  legalNotice: {
    id: 'footer.legal_notice',
  },
  sitemap: {
    id: 'footer.sitemap',
  },
  lexique: {
    id: 'footer.lexique',
  },
  contactUs: {
    id: 'footer.contact_us',
  },
  cookies: {
    id: 'footer.cookies',
  },
  faq: {
    id: 'footer.faq',
  },

  allRightsReserved: {
    id: 'footer.all_rights_reserved',
  },
});
